module.exports = {
  response_failed: 'Your answer could not be generated. Please ask the question again.',
  ai_generated_warning: 'This answer is AI generated. Always cross-check AI content with trusted information sources.',
  appointments: 'Appointments',
  ask_button: 'Ask',
  ask_community: 'Ask community',
  all_done_title: 'Great, you completed all tasks!',
  ask_community_button: 'Yes, ask community',
  ask_community_error: 'Error loading community data',
  ask_community_loading: 'Loading community data...',
  ask_community_prompt: 'Would you like to ask this question in the community?',
  citation: {
    title: 'Citation',
    view_file: 'Open File',
  },
  cover_image_course_alt: 'Course cover image',
  cover_image_news_alt: 'News image cover image',
  create_post: {
    title: 'Create Post',
    community_label: 'Community',
    content_label: 'Post',
    content_placeholder: 'What do you want to share or ask?',
    submitting: 'Posting...',
    submit: 'Post',
    community_required_warning: 'Please select a community before posting.',
    you: 'You',
  },
  debug_requests: 'Debug Requests',
  ai_response_title: 'Search Result',
  debug_requests_title: 'Debug Community Post Answer Requests',
  from_opponent: 'From %{opponent}',
  go_back: 'Go back',
  listening_placeholder: 'I am listening...',
  heroText: {
    goodMorning: 'Good morning, {name}!',
    hello: 'Hello, {name}!',
    goodEvening: 'Good evening, {name}!',
    midnightOil: 'Burning the midnight oil, {name}?',
    welcomeBack: 'Welcome back, {name}!',
    readyToLearn: 'Ready to learn something new, {name}?',
    makeProductive: 'Let’s make today productive, {name}!',
    doingGreat: 'You’re doing great, {name}!',
    easterEgg: {
      bananaBerry: 'Bananas are berries, but strawberries aren’t.',
      octopusHearts: 'Octopuses have three hearts.',
      flamboyance: 'A group of flamingos is called a “flamboyance”.',
      eiffelTaller: 'The Eiffel Tower can be 15 cm taller in summer.',
      venusDay: 'A day on Venus is longer than a year on Venus.',
      beeFaces: 'Honeybees can recognize human faces.',
      strawberriesAreNuts: 'Strawberries are nuts.',
      bluetoothVikingKing: 'Bluetooth is named after a Viking king.',
      atSymbolOlderThanEmail: 'The "@" symbol is older than email.',
    },
  },
  modal_title: 'Ask Keelearning',
  my_open_tasks: 'My Open Tasks',
  new_image_alt: 'New image',
  new_quiz_image_alt: 'New quiz image',
  news: 'News',
  available_communities: 'Available Communities',
  available_videos: 'Available Videos',
  community_updates: 'Community Updates',
  whats_new: "What's New",
  home_navigation: {
    label: 'Home sections',
    dashboard: 'Dashboard',
    feed: 'Feed',
  },
  community_update_filters: {
    all: 'All',
    today: 'Today',
    this_week: 'This Week',
    this_month: 'This Month',
  },
  new_community_posts: 'New Community Posts',
  new_files: 'New Files',
  new_news: 'New News',
  no_results_answer: 'No results were found for your question. You can ask a more general question or add some keywords to your question.',
  open_modal: 'Open Modal',
  pending_courses: 'Pending Courses',
  post_actions: 'Post actions',
  quiz_battle_requests: 'Quiz Battle Requests',
  quiz_battles: 'Quiz Battles',
  quiz_cover_image_alt: 'Quiz cover image',
  question_placeholder: 'What do you want to know?',
  like_post: 'Like',
  question_title: 'Your Question',
  rate_up: 'Rate up',
  rate_down: 'Rate down',
  rating_prompt: 'Was this reply helpful?',
  related_posts: 'Related posts',
  related_media_files: 'Related Media Files',
  start_quiz_battle: 'Start Quiz Battle',
  start_listening: 'Start speech recognition',
  stop_listening: 'Stop speech recognition',
  unanswered_question: "Your question hasn't been answered?",
  updated_image_alt: 'Updated image',
  updated_quiz_image_alt: 'Updated quiz image',
  post_created_toast: 'Post successfully created!',
}
